<script setup lang="ts">
import type { TabsItem } from '@nuxt/ui'

const { t } = useI18n()

const items = ref<TabsItem[]>([
  {
    icon: 'i-lucide:sun',
    value: 'light',
    label: t('Light')
  },
  {
    icon: 'i-lucide:moon',
    value: 'dark',
    label: t('Dark')
  },
  {
    icon: 'i-lucide:monitor',
    value: 'system',
    label: t('System')
  }
])

const active = ref('system')
const colorMode = useColorMode()

onMounted(() => {
  colorMode.preference = window?.localStorage?.getItem('nuxt-color-mode') || colorMode.value
})

watch(active, (newVal) => {
  colorMode.preference = newVal
})
</script>

<template>
    <UTabs
        v-model="active"
        orientation="vertical"
        variant="pill"
        :content="false"
        :items="items"
        class="w-full"
    />
</template>
